module.exports = __webpack_public_path__ + "static/media/back-arrow.a454556e.svg";